import React from "react";
import { useInstantSearch } from "react-instantsearch";
import { FormControl, Select, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortAmountDesc, faSortAmountAsc, faSortAlphaAsc } from "@fortawesome/free-solid-svg-icons";
import { getSortOptions, getCurrentSortKey, setCurrentSortKey } from "./sortStore";

const ICON_MAP = {
  sort_amount_desc: <FontAwesomeIcon icon={faSortAmountAsc} />,
  sort_amount_asc:  <FontAwesomeIcon icon={faSortAmountDesc} />,
  sort_alpha_asc:   <FontAwesomeIcon icon={faSortAlphaAsc} />,
};

export default function TriPar() {
  const { refresh } = useInstantSearch();
  const sortKey = getCurrentSortKey();
  const options = getSortOptions();

  const handleChange = (e) => {
    setCurrentSortKey(e.target.value);
    refresh();
  };

  return (
    <div className="sui-facet">
      <legend className="sui-facet__title">Trier par</legend>
      <FormControl size="small" fullWidth>
        <Select
          value={sortKey}
          onChange={handleChange}
          className="sui-select"
          renderValue={(value) => {
            const opt = options.find((o) => o.key === value);
            return (
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {ICON_MAP[opt?.icon]}
                {opt?.label}
              </span>
            );
          }}
          sx={{
            fontSize: "0.85rem",
            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e0e0" },
          }}
        >
          {options.map((opt) => (
            <MenuItem key={opt.key} value={opt.key} dense>
              <ListItemIcon sx={{ minWidth: 32 }}>
                {ICON_MAP[opt.icon]}
              </ListItemIcon>
              <ListItemText>{opt.label}</ListItemText>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
